// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"710":"6f89c5ac8de3819a","1688":"9eaad40e7710b40f","1956":"89af895813251b6f","3065":"5a8b2ed2269c8a13","8021":"0ca3a6f6363d1f18","8082":"0ea9c95b7ca9c033"}[chunkId] + ".css";
};